import Button from '../../../../components/Button';
import styles from './style.m.less';

type Props = {
    onDismiss: () => void;
};

export function ResultColumnHint({ onDismiss }: Props) {
    return (
        <div className={styles.container}>
            <strong>
                New in <img alt="SI" src={require('../Logo.svg')} className={styles.logo} />:
            </strong>{' '}
            Show rated answers directly in the table with custom columns!{' '}
            <Button kind="LINK" onClick={onDismiss}>
                Hide
            </Button>
            .
            <img alt="" src={require('../Arrow.png')} className={styles.arrow} />
        </div>
    );
}
